// RESILIGENT Website Mock Data

export const brandAssets = {
  logoWhite: "/opt/brand/resiligent-logo-rebrand-06.webp",
  logoColor: "/opt/brand/resiligent-logo-full-colour.webp",
  discLens: "/opt/photo/disc-l3ns.webp",
  discLensAfrica: "/opt/photo/disc-lens-africa.webp",
  discLensTeams: "/opt/photo/disc-lens-teams.webp"
};

export const heroImages = [
  {
    url: "/opt/photo/ext/p2976970.webp",
    alt: "Executive boardroom",
    position: "center"
  },
  {
    url: "/opt/photo/strategy.webp",
    alt: "Strategy session",
    position: "center"
  },
  {
    url: "/opt/photo/assessment-head.webp",
    alt: "Assessment and leadership",
    position: "right center"
  }
];

export const heroData = {
  headline: "Advisory-led leadership and organisational development for complex organisations.",
  subheadline: "Delivered through proprietary intelligence, deep contextual understanding, and disciplined execution.",
  supportLine: "We partner with boards, executives, and HR leaders to diagnose, prioritise, and activate leadership and culture at scale.",
  primaryCta: "Explore how we work",
  secondaryCta: "Discover Impact AS Plus\u2122"
};

export const howWeWorkData = {
  sectionTitle: "How We Work",
  introLine: "Our work follows a disciplined, insight-led approach designed for regulated and high-stakes environments.",
  steps: [
    {
      id: 1,
      title: "Diagnose",
      description: "We use our proprietary Impact AS Plus\u2122 leadership and organisational intelligence system to surface leadership, cultural, and execution signals across individuals, teams, and organisations."
    },
    {
      id: 2,
      title: "Prioritise",
      description: "We support leadership teams to interpret insight, identify patterns, and focus on what will genuinely shift performance and behaviour."
    },
    {
      id: 3,
      title: "Activate",
      description: "Through targeted coaching, leadership development, and organisational interventions, we translate insight into sustained behaviour change."
    },
    {
      id: 4,
      title: "Sustain",
      description: "We help organisations monitor progress, reinforce accountability, and embed leadership and cultural discipline over time."
    }
  ]
};

export const impactASPlusData = {
  sectionTitle: "Proprietary Leadership and Organisational Intelligence",
  bodyPara1: "At the core of our work is Impact AS Plus\u2122 \u2014 RESILIGENT's proprietary leadership and organisational intelligence system.",
  bodyPara2: "Impact AS Plus integrates diagnostics across individual, team, and organisational levels, enabling organisations to see leadership capability, cultural dynamics, and execution risk in one coherent view.",
  bodyPara3: "It underpins our advisory work and allows us to deliver insight-led interventions with clarity, consistency, and governance.",
  cta: "Explore Impact AS Plus\u2122",
  image: "/opt/photo/black-lady-sitting-down.webp"
};

export const whereWeOperateData = {
  sectionTitle: "Where We Operate",
  introLine: "We work with organisations where leadership judgement, governance, and cultural discipline matter.",
  sectors: [
    {
      name: "Financial Services & Banking",
      description: "Our deep financial services experience means we deliver interventions calibrated to the high-pace demands of the sector, from boardroom governance to front-line execution, aligned with the distinct leadership needs at each level of the institution."
    },
    {
      name: "Regulators & Public Sector",
      description: "We understand the unique accountability and stakeholder complexity of public institutions. Our work helps leaders navigate regulatory mandates while building the internal capability to deliver sustainable public value."
    },
    {
      name: "Large Corporates & Multinationals",
      description: "For established organisations managing scale and complexity, we bring rigour to leadership development, succession planning, and culture alignment, ensuring leadership capability keeps pace with strategic ambition."
    },
    {
      name: "Infrastructure, Energy & Complex Operations",
      description: "In capital-intensive, operationally complex environments, leadership judgement carries significant risk. We equip leaders to navigate safety-critical decisions, regulatory demands, and stakeholder expectations with confidence."
    },
    {
      name: "SMEs & Growth-Stage Businesses",
      description: "We understand the micro-cultures and founder dynamics that define growing businesses. Our approach helps SME leaders professionalise without losing the agility and entrepreneurial edge that drive growth."
    },
    {
      name: "Startups & Entrepreneurial Ventures",
      description: "For founders and early-stage leadership teams, we provide the frameworks to scale leadership capability alongside the business, building the people infrastructure needed to move from startup to sustainable enterprise."
    }
  ],
  trustLine: "Trusted by banks, DFIs, SMEs, startups, public sector and multinationals across Africa."
};

export const clientOutcomesData = {
  sectionTitle: "What This Means for Our Clients",
  outcomes: [
    "Clear visibility of leadership and cultural dynamics",
    "Confident prioritisation of development and intervention",
    "Reduced execution and people risk",
    "Insight-led coaching and leadership development",
    "Sustainable change, not episodic programmes",
    "Measurable return on leadership investment"
  ]
};

export const philosophyData = {
  sectionTitle: "Our Philosophy",
  bodyPara1: "We believe leadership and organisational development must be grounded in evidence, interpreted with judgement, and activated with discipline.",
  bodyPara2: "Data alone does not change behaviour. Nor does intuition without insight. Our work sits at the intersection of rigorous diagnostics, contextual understanding, and human capability."
};

export const aboutData = {
  sectionTitle: "About RESILIGENT",
  bodyPara1: "RESILIGENT is a leadership and organisational development firm with deep experience supporting complex organisations across Africa and beyond.",
  bodyPara2: "Our work spans boards, executive teams, and senior leadership populations, with a focus on leadership effectiveness, ethical behaviour, culture, and execution.",
  bodyPara3: "We combine global best practice with grounded contextual insight to help organisations navigate complexity with confidence.",
  cta: "Learn more about RESILIGENT"
};

export const finalCtaData = {
  headline: "Ready to explore what insight-led leadership and organisational development could look like in your organisation?",
  primaryCta: "Start a conversation",
  secondaryCta: "Discover Impact AS Plus\u2122"
};

export const testimonials = [
  {
    quote: "The expert understanding and carefully crafted solutions tailored to our unique needs have set a new standard for excellence.",
    author: "CEO",
    company: "Kedari Capital"
  },
  {
    quote: "The marriage of data analysis and human insights created strategies that provided enduring solutions to our challenges.",
    author: "CEO",
    company: "Fenchurch Group"
  },
  {
    quote: "Hands down the best leadership programme we have attended. The approach, delivery and logistics were top notch.",
    author: "Senior Manager",
    company: "Central Bank of Nigeria"
  }
];

export const trustedByLogos = [
  { name: "Central Bank of Nigeria", url: "/opt/logos/cbn.webp" },
  { name: "African Development Bank", url: "/opt/logos/afdb.webp" },
  { name: "Bank of Industry", url: "/opt/logos/boi.webp" },
  { name: "Union Bank", url: "/opt/logos/union-bank.webp" },
  { name: "Polaris Bank", url: "/opt/logos/polaris.webp" },
  { name: "Deutsche Bank", url: "/opt/logos/deutsche-bank.webp" },
  { name: "Barclays", url: "/opt/logos/barclays.webp" },
  { name: "BNP Paribas", url: "/opt/logos/bnp-paribas.webp" },
  { name: "Citi", url: "/opt/logos/citi.webp" },
  { name: "Scotiabank", url: "/opt/logos/scotiabank.webp" },
  { name: "Amazon", url: "/opt/logos/amazon.webp" },
  { name: "Vodafone", url: "/opt/logos/vodafone.webp" },
  { name: "Fujitsu", url: "/opt/logos/fujitsu.webp" },
  { name: "Coca-Cola", url: "/opt/logos/coca-cola.webp" },
  { name: "Danone", url: "/opt/logos/danone.webp" },
  { name: "JTI", url: "/opt/logos/jti.webp" },
  { name: "Irish Distillers", url: "/opt/logos/irish-distillers.webp" },
  { name: "NLNG", url: "/opt/logos/nlng.webp" },
  { name: "Booking.com", url: "/opt/logos/booking.webp" },
  { name: "Fenchurch Group", url: "/opt/logos/fenchurch-group.webp" },
  { name: "Fenchurch Energy", url: "/opt/logos/fenchurch-energy.webp" },
  { name: "Fenchurch Power", url: "/opt/logos/fenchurch-power.webp" },
  { name: "Kedari Capital", url: "/opt/logos/kedari-capital.webp" },
  { name: "MBO Capital", url: "/opt/logos/mbo-capital.webp" },
  { name: "Molten Ventures", url: "/opt/logos/molten-ventures.webp" },
  { name: "Utilita", url: "/opt/logos/utilita.webp" },
  { name: "Life Flour Mill", url: "/opt/logos/life-flour-mill.webp" },
  { name: "Lagos Business School", url: "/opt/logos/lagos-business-school.webp" },
  { name: "Delta State", url: "/opt/logos/delta-state.webp" },
  { name: "Michelson", url: "/opt/logos/michelson.webp" },
  { name: "Secondary", url: "/opt/logos/secondary.webp" },
  { name: "Webclip", url: "/opt/logos/webclip.webp" }
];

export const navLinks = [
  { label: "Engagement", href: "/engagement", fullName: "How Organisations Engage RESILIGENT" },
  { label: "Impact AS Plus™", href: "/impact-as-plus", fullName: "Impact AS Plus™ - Leadership Intelligence System" },
  { label: "Diagnostics", href: "/diagnostics", fullName: "Diagnostics & Insight Reports" },
  { label: "Coaching", href: "/coaching", fullName: "Coaching & Leadership Development" },
  { label: "Capability", href: "/capability-building", fullName: "Capability Building and Training" },
  { label: "Advisory", href: "/advisory", fullName: "Advisory & Organisational Change" },
  { label: "Case Studies", href: "/case-studies", fullName: "Case Studies & Clients" }
];

export const contactInfo = {
  email: "info@resiligent.com",
  phoneAfrica: "+234 (0)703 009 0712",
  phoneEurope: "+44 (0)207 117 630 7",
  addressAfrica: "154 Prince Ade Odedina Street, Victoria Island, Lagos",
  addressEurope: "Monomark House, 27 Old Gloucester Street, WC1N 3AX, London UK"
};
